module.exports = __webpack_public_path__ + "img/top6.F.e96fb53e.png";